<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Distribution.Fields.logistic_info") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <ValidationObserver ref="observer">
          <v-container>
            <v-row align="center" dense>
              <v-col cols="2" class="text-right">
                {{
                  $t("Distribution.Fields.logistics_company") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistics_company')"
                  rules="required"
                >
                  <SearcherLogistic
                    v-model="logisticCompany"
                    noLabel
                    :hint="$t('Distribution.logisticCompanyHint')"
                    :error-messages="errors"
                    :disabled="isDisabled"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="2" class="text-right">
                {{
                  $t("Distribution.Fields.logistic_price") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="4">
                <!-- <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistic_price')"
                  rules="required"
                > -->
                <v-text-field
                  v-model="logisticPrice"
                  clearable
                  single-line
                  type="number"
                  :disabled="isDisabled"
                />
                <!-- </ValidationProvider> -->
              </v-col>
            </v-row>
            <v-row v-if="logisticCompany" align="center" dense>
              <v-col cols="2" class="text-right">
                {{ $t("Distribution.Fields.linkman") + $t("Global.colon") }}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="linkman"
                  single-line
                  readonly
                  :disabled="isDisabled"
                />
              </v-col>
              <v-col cols="2" class="text-right">
                {{
                  $t("Distribution.Fields.contact_number") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="contact_number"
                  single-line
                  readonly
                  :disabled="isDisabled"
                />
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{
                  $t("Distribution.Fields.logistic_code") + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9">
                <!-- <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Distribution.Fields.logistic_code')"
                  rules="required"
                > 去除物流单号必填 -->
                <v-textarea
                  outlined
                  v-model="logisticCodes"
                  :placeholder="$t('Distribution.logisticCodePlaceholder')"
                  :hint="
                    distribution.status >= 3
                      ? ''
                      : $t('Distribution.logisticCodeHint')
                  "
                  :readonly="distribution.status >= 3"
                  :disabled="isDisabled"
                ></v-textarea>
                <!-- </ValidationProvider> -->
              </v-col>
            </v-row>
            <v-row align="start" dense>
              <v-col cols="2" class="text-right">
                {{$t("Distribution.Fields.logistics_img") + $t("Global.colon")}}
              </v-col>
              <v-col cols="3" v-for="(img, i) in album" :key="i">
                <v-img v-if="img" :src="img" @click.stop="$showFullscreenImages([img])">
                  <v-tooltip right v-if="img && !isDisabled">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="pa-2 float-right"
                        @click.stop="removeFromImages(i)"
                      >fa-times</v-icon>
                    </template>
                    <span> {{ $t("Material.delImg") }}</span>
                  </v-tooltip>
                </v-img>
              </v-col>
            </v-row>
            <v-row align="start" dense v-if="!isDisabled">
              <v-col cols="2" class="text-right">
              </v-col>
              <v-col cols="9">
                <!-- 上传物流图片 -->
                <v-file-input
                  ref="img_file"
                  show-size
                  counter
                  small-chips
                  multiple
                  suffix
                  prepend-icon="fa-camera"
                  accept="image/png, image/jpeg"
                  persistent-hint
                  :placeholder="$t('Material.imgsPlaceholder')"
                  :hint="$t('Material.imgsHint')"
                  :rules="imgRules"
                  v-model="img_file"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          v-if="distribution.status == 1"
          color="primary"
          depressed
          outlined
          @click="submit(true)"
        >
          {{ $t("Distribution.actions.logisticAndDistribute") }}
        </v-btn>
        <v-btn
          v-if="distribution.status < 3"
          color="accent"
          depressed
          @click="submit()"
        >
          {{ $t("$vuetify.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SearcherLogistic from "@/components/plugins/SearcherLogistic";
import Distributions from "@/api/distributions";
import Files from "@/api/files";

export default {
  name: "EditLogisticAlert",

  props: {
    value: Boolean,
    title: String,
    persistent: Boolean,
    distribution: Object,
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    SearcherLogistic,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    dialog: false,
    logisticCompany: null,
    logisticPrice: "",
    linkman: "",
    contact_number: "",
    logisticCodes: "",
    imgRules: [(value) => !value || value.filter((v) => v.size >= 10000000).length == 0 || i18n.t("Material.imgsHint")],
    img_file: null,
    album: [],
    isDisabled: false
  }),

  methods: {
    submit(distribution_flg) {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理物流单号
            let logistic_codes = this.logisticCodes.replace("\n", ";");
            let logistics_img = []
            if (this.img_file) {
              let response = await Files.imagesUpload(this.img_file, false, 'images');
              if (response.data.status.isOK()) {
                logistics_img = (response.data.data && response.data.data.length) ? response.data.data.map((img) => img.img_name) : []
              } else {
                this.$snackbar.error(i18n.t("Material.imgUploadError"));
                this.$store.dispatch("fullscreenLoadingStop");
                return ;
              }
            }
            if (logistics_img.length == 0 && this.distribution.logistics_img_url && this.distribution.logistics_img_url.length > 0) {
              logistics_img = this.album.map((img) => img.substring(img.lastIndexOf('/') + 1))
            }

            Distributions.editLogistic({
              id: this.distribution.id,
              logistics_price: this.logisticPrice,
              logistics_code: logistic_codes,
              logistics_id: this.logisticCompany.id,
              distribution_flg: distribution_flg ? 1 : 0,
              logistics_img: logistics_img
            })
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.dialog = false;
                    this.album = [];
                    this.img_file = null;
                    this.$emit("editLogistic", null);
                    this.$refs.observer.reset();
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      if (this.img_file) {
        this.img_file.splice(i, 1);
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.$emit("close");
          this.img_file = null;
          this.album = [];
          this.isDisabled = false;
          this.$refs.observer.reset();
        } else {
          this.logisticCompany = this.distribution.logistics_name
            ? {
                id: this.distribution.logistics_id,
                Description:
                  this.distribution.logistics_name +
                  " - " +
                  this.distribution.logistics_link_man,
              }
            : null;

          this.logisticPrice =
            this.distribution.logistics_price != null
              ? this.distribution.logistics_price
              : "";
          this.linkman = this.distribution.logistics_link_man
            ? this.distribution.logistics_link_man
            : "";
          this.contact_number = this.distribution.contact_method
            ? this.distribution.contact_method
            : "";
          this.logisticCodes = this.distribution.logistics_code
            ? this.distribution.logistics_code
            : "";
          this.album = this.distribution.logistics_img_url ? this.distribution.logistics_img_url : [];
          if (this.settings && this.settings.paid_close_order_fee == 1) {
            // 当《已支付不可手动修改订单运费》开启时
            if (this.distribution.status == 3) {
              // 已完成的配送单禁止修改物流信息
              this.isDisabled = true;
            } else {
              // 其他状态的配送单，只能填写一次物流信息
              if (this.distribution.logistics_id) {
                this.isDisabled = true;
              } else {
                this.isDisabled = false;
              }
            }
          } else {
            // 当《已支付不可手动修改订单运费》 未开启时
            if (this.settings && this.settings.bill_express_fee_actual == 1) {
              // 当《账单响应实际运费》开启时
              if (this.distribution.status == 3) {
                // 已完成的配送单禁止修改物流信息
                this.isDisabled = true;
              } else {
                // 其他状态的配送单，只能填写一次物流信息
                if (this.distribution.logistics_id) {
                  this.isDisabled = true;
                } else {
                  this.isDisabled = false;
                }
              }
            } else {
              // 当《已支付不可手动修改订单运费》 未开启时
              // 当《账单响应实际运费》 未开启时
              if (this.distribution.status == 3) {
                // 已完成的配送单禁止修改物流信息
                this.isDisabled = true;
              } else {
                // 其他状态的配送单
                this.isDisabled = false;
                }
              }
            }
        }
      },
    },
    logisticCompany: {
      handler() {
        if (Object.keys(this.logisticCompany).length > 2) {
          this.linkman = this.logisticCompany.linkman;
          this.contact_number = this.logisticCompany.contact_method;
        } else if (this.logisticCompany.Description) {
          var data = this.logisticCompany.Description.split(" - ");
          this.logisticCompany.logistics_name = data[0];
        }
      },
    },
    logisticCodes: {
      handler() {
        this.logisticCodes = this.logisticCodes.replace(";", "\n");
      },
    },
    img_file: {
      deep: true,
      handler() {
        this.album = [];
        if (this.img_file) {
          if (this.img_file.length > 3) {
            this.$snackbar.error(i18n.t("Material.hint"));
            this.img_file = [];
          }else {
            this.img_file.forEach((img, i) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.splice(i, 0, this.result);
              };
            });
          }
        }
      },
    },
  },
};
</script>
